import type { RootState } from 'typesafe-actions';

export const getDeviceType = (state: RootState) => state.deviceType;
